import React , {useEffect,useState,useCallback} from 'react';
import { useWallet } from '../WalletProvider';

function VipTimerTron({showTimer}) {

    const[vip, setVip] = useState({
        isVip:false,
        end : 0
    })
    const {account, currencyDetails } = useWallet();
    
    const now = Math.floor(((new Date()).getTime())/1000);
    
    const calculateTimeLeft = useCallback(() => {
        if(Number(vip.end) > now){
            const number = Number(vip.end) - Number(now);
            return number;
        }
        return 0;
    },[vip.end, now]);

    let [count, setCount] = useState(calculateTimeLeft());
    
    useEffect(() => {
        let isApiSubscribed = true;
        const checkuser = async()=>{
            if(account){
                const contract = await window.tronWeb.contract().at(currencyDetails.airdropAddress);
                const VIP = await contract.isGrantedPremiumMember(account).call();
                if(VIP){
                    const endTime = await contract.membershipExpiryTime(account).call();
                    setVip({
                        isVip : true,
                        end : Number(endTime)
                    })
                } 
            }
        }
        if(isApiSubscribed){
            checkuser();
            setTimeout(() => {
                setCount(calculateTimeLeft());
            }, 1000);
        }
        
        
        return () => {
            isApiSubscribed = false;
        }

    },[currencyDetails.airDropContract, account, showTimer, calculateTimeLeft, currencyDetails.airdropAddress]);

    useEffect(() => {
        const interval = setInterval(() => {
        if (Number(count) > 0) {
            setCount(--count);
        }else{
            setCount(0);
        }
        }, 1000);
        return () => clearInterval(interval);

    }, [count]);

  return (
    <>
    {vip.isVip ? (<div className="strttime">
        <div className="">{Math.floor(count / (60 * 60 * 24))}d</div>
        :
        <div className="">{Math.floor((count % (60 * 60 * 24)) / (60 * 60))}h</div>
        :
        <div className="">{Math.floor((count % (60 * 60)) / (60))}m</div>
        :
        <div className="">{Math.floor((count % (60)))}s</div>
    </div>) :null}
    </> 
  )
}

export default VipTimerTron